import { useStore } from 'framework7-vue'

import { ToReadableTime } from '@/assets/composables/mappers'
import { ParkingReservationSuccessEvent, VehicleRequest } from '@/assets/composables/types'

const umamiEvent = (eventName: string, data: object) => {
  try {
    // @ts-ignore
    umami.track(eventName, data)
  } catch (error) {
    console.error(error)
  }
}

export const trackParkingReservationSuccess = ({
  date,
  partOfDay,
}: ParkingReservationSuccessEvent) => {
  umamiEvent('parking-reservation-add-success', {
    email: useStore('user').value.email,
    date,
    partOfDay: ToReadableTime(partOfDay, false),
  })
}

export const trackParkingVehicleAddSuccess = ({
  ecv,
  brand,
  model,
}: Pick<VehicleRequest, 'ecv' | 'brand' | 'model'>) => {
  umamiEvent('parking-vehicle-add-success', {
    email: useStore('user').value.email,
    ecv,
    brand,
    model,
  })
}
